module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av621-a0b394eff3d4b248d46a9dee7e9758b0.jpg";